export enum SensorEventType {
  default = 'default',
  warning = 'warning',
  error = 'error',
}
